
// import React, { useState, useEffect } from 'react';
// import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
// import axios from 'axios';
// import mainImg from '../../Assets/speeches/v1_83.png';
// import microphoneIcon from '../../Assets/icons/icon3.png';
// import speechesIcon from '../../Assets/icons/icon2.png';
// import videosIcon from '../../Assets/icons/icon4.png';
// import productionsIcon from '../../Assets/icons/icon1.png';

// import videoStyles from './Videos.module.css';
// import audioStyles from './Audio.module.css';
// import speechesStyles from './Speeches.module.css';
// import productStyles from './Products.module.css'

// const MediaBrowser = () => {
//   const { year } = useParams(); 
//   const navigate = useNavigate();
//   const location = useLocation(); 
//   const activeYear = year ? parseInt(year) : 1403; 

//   const englishToPersian = (num) => {
//     const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
//     const englishDigits = '0123456789';
//     return String(num).replace(/[0-9]/g, (digit) => persianDigits[englishDigits.indexOf(digit)]);
//   };

//   const persianToEnglish = (str) => {
//     const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
//     const englishDigits = '0123456789';
//     return String(str).replace(/[۰-۹]/g, (digit) => englishDigits[persianDigits.indexOf(digit)]);
//   };

//   //dynamic routing based on the page
//   const getMediaTypeFromPath = () => {
//     const path = location.pathname;
//     if (path.includes('/videos')) return 'videos';
//     if (path.includes('/audios')) return 'audios';
//     if (path.includes('/speeches')) return 'speeches';
//     if (path.includes('/productions')) return 'productions';
//     return 'speeches'; 
//   };

//   const currentMediaType = getMediaTypeFromPath();

//   const [items, setItems] = useState([]);
//   const [loadingState, setLoadingState] = useState(false);
//   const [displayedItems, setDisplayedItems] = useState(10);
//   const [totalItems, setTotalItems] = useState(0);
//   const [yearNavigationIndex, setYearNavigationIndex] = useState(0);
//   const [categoryType, setCategoryType] = useState(currentMediaType); 
//   const [error, setError] = useState(null);


//   //dynamic Api tyle picking
//   const getAPIConfig = (type) => {
//   const configs = {
//     speeches: {
//       function: 'getSpeechesByYear',
//       routePrefix: 'speeches',
//       defaultItemsPerPage: 10,
//       loadMoreIncrement: 10,
//       category: 'speech'
//     },
//     videos: {
//       function: 'getVideosByYear',
//       routePrefix: 'videos', 
//       defaultItemsPerPage: 16,
//       loadMoreIncrement: 8,
//       category: 'video'
//     },
//     audios: {
//       function: 'getAudiosByYear',
//       routePrefix: 'audios',
//       defaultItemsPerPage: 10, 
//       loadMoreIncrement: 10,
//       category: 'audio'
//     },
//     productions: {
//       // function: 'getProductionsByYear',
//       function: 'getAllProductions',
//       routePrefix: 'productions',
//       defaultItemsPerPage: 12,
//       loadMoreIncrement: 6,
//       category: 'production'
//     }
//   };

//   return configs[type] || configs.speeches;
// };


//   const apiConfig = getAPIConfig(categoryType);

//   useEffect(() => {
//     const urlMediaType = getMediaTypeFromPath();
//     if (urlMediaType !== categoryType) {
//       setCategoryType(urlMediaType);
//       setDisplayedItems(getAPIConfig(urlMediaType).defaultItemsPerPage);
//       setItems([]); 
//     }
//   }, [location.pathname]); 

//   const formatSlugForURL = (slug) => {
//     if (!slug) return '';
//     return slug.replace(/\s+/g, '-').trim();
//   };

//   const getStyles = () => {
//   switch(apiConfig.category) {
//     case 'video':
//       return videoStyles;
//     case 'audio':
//       return audioStyles;
//     case 'production':
//       return productStyles;
//     case 'speech':
//     case 'speeches':
//     default:
//       return speechesStyles;
//   }
// };

//   //dynamic picking for the icon that will be used the the pages ALL content load
//   const getCategoryIcon = (category) => {
//     switch(category) {
//       case 'speech':
//       case 'speeches':
//         return speechesIcon;
//       case 'audio':
//         return microphoneIcon;
//       case 'video':
//         return videosIcon;
//       case 'production':
//       case 'productions':
//         return productionsIcon;
//       default:
//         return speechesIcon;
//     }
//   };

//   const styles = getStyles();
  
//   // edit the users for production
//   let visibleYearRange;
//   let availableYears;

//   if (apiConfig.category === 'production') {
//     availableYears = Array.from({ length: 34 }, (_, i) => 1404 - i);
//     visibleYearRange = availableYears.slice(yearNavigationIndex, yearNavigationIndex + 4);
//   }else {
//     availableYears = Array.from({ length: 34 }, (_, i) => 1403 - i);
//     visibleYearRange = availableYears.slice(yearNavigationIndex, yearNavigationIndex + 4);
//   }

//   // const gregorianToPersianYear = (gregorianDate) => {
//   //   const date = new Date(gregorianDate);
//   //   const gregorianYear = date.getFullYear();
//   //   return gregorianYear - 621;
//   // };

//   // const persianToGregorianYear = (persianYear) => {
//   //   return persianYear + 621;
//   // };

//   // const formatPersianDate = (dateString) => {
//   //   const date = new Date(dateString);
//   //   const formatted = new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
//   //     year: 'numeric',
//   //     month: '2-digit',
//   //     day: '2-digit'
//   //   }).format(date);
//   //   return englishToPersian(formatted); 
//   // };

//   const gregorianToPersianYear = (gregorianDate) => {
//     const date = new Date(gregorianDate);
//     const year = date.getFullYear();
//     const month = date.getMonth() + 1;
//     const day = date.getDate();
    
//     if (month < 3 || (month === 3 && day < 21)) {
//         return year - 622;
//     }
//     return year - 621;
// };

// const persianToGregorianYear = (persianYear) => {
//     return persianYear + 621;
// };

// const formatPersianDate = (dateString) => {
//     const date = new Date(dateString);
//     const formatted = new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
//         year: 'numeric',
//         month: '2-digit',
//         day: '2-digit'
//     }).format(date);
//     return englishToPersian(formatted);
// };


//   const sortItemsByDate = (items) => {
//     return items.sort((a, b) => {
//       const dateA = new Date(a.originalDate || a.date);
//       const dateB = new Date(b.originalDate || b.date);
//       return dateB - dateA;
//     });
//   };

//   let lanuagePicked = localStorage.getItem('siteLanguage');
//   let apiUrl = "";

//   useEffect(() => {
//   const fetchItems = async () => {
//     setLoadingState(true);
//     setItems([]);
//     setError(null);

//     try {
//       const gregorianYear = persianToGregorianYear(activeYear);
//       const nextGregorianYear = gregorianYear + 1; 

//       let apiUrl1 = "";
//       let apiUrl2 = "";
      
//       if (lanuagePicked === "fa") {
//         apiUrl1 = `https://api.nasrollah.info/fa/?function=${apiConfig.function}&params=${gregorianYear}`;
//         apiUrl2 = `https://api.nasrollah.info/fa/?function=${apiConfig.function}&params=${nextGregorianYear}`;
//       } else {
//         apiUrl1 = `https://api.nasrollah.info/ar/?function=${apiConfig.function}&params=${gregorianYear}`;
//         apiUrl2 = `https://api.nasrollah.info/ar/?function=${apiConfig.function}&params=${nextGregorianYear}`;
//       }

//       const requestConfig = {
//         timeout: 15000,
//         headers: {
//           'Accept': 'application/json',
//           'Content-Type': 'application/json',
//         }
//       };

//       const [response1, response2] = await Promise.all([
//         axios.get(apiUrl1, requestConfig),
//         axios.get(apiUrl2, requestConfig)
//       ]);

//       const data1 = Array.isArray(response1.data) ? response1.data : [];
//       const data2 = Array.isArray(response2.data) ? response2.data : [];
//       const combinedData = [...data1, ...data2];

//       if (combinedData.length > 0) {
//         let transformedItems = combinedData
//           .map(item => ({
//             id: item.id_post,
//             title: item.title_post,
//             slug: item.slug_post,
//             author: item.author_post,
//             date: item.create_time_post,
//             originalDate: item.original_time_post,
//             status: item.status_post,
//             featured_media: item.featured_media_post,
//             featured_cover: item.featured_post,
//             content: item.html_post,
//             category: item.name_category || apiConfig.category,
//             keywords: item.keywords_post,
//             description: item.meta_description_post
//           }))
//           .filter(item => {
//             const itemPersianYear = gregorianToPersianYear(item.originalDate || item.date);
//             return itemPersianYear === activeYear;
//           });

//         transformedItems = sortItemsByDate(transformedItems);
        
//         const paginatedItems = transformedItems.slice(0, displayedItems);

//         setItems(paginatedItems);
//         setTotalItems(transformedItems.length);

//       } else {
//         setItems([]);
//         setTotalItems(0);
//       }
//     } catch (error) {
//       console.error('Error fetching items:', error);
//       setError({
//         message: error.message,
//         status: error.response?.status,
//         type: 'fetch_error'
//       });
//       setItems([]);
//       setTotalItems(0);
//     }

//     setLoadingState(false);
//   };

//   fetchItems();
// }, [activeYear, displayedItems, categoryType, apiConfig.function, lanuagePicked]);
//   const handleYearSelection = (year) => {
//     navigate(`/${apiConfig.routePrefix}/${year}`);
//     setDisplayedItems(apiConfig.defaultItemsPerPage);
//   };

//   const handleShowMoreItems = () => {
//     setDisplayedItems(prev => prev + apiConfig.loadMoreIncrement);
//   };

//   const navigateToNewerYears = () => {
//     if (yearNavigationIndex > 0) {
//       setYearNavigationIndex(prev => prev - 4);
//     }
//   };

//   const navigateToOlderYears = () => {
//     if (yearNavigationIndex + 4 < availableYears.length) {
//       setYearNavigationIndex(prev => prev + 4);
//     }
//   };

//   const formatDisplayDate = (item) => {
//     const dateToFormat = item.originalDate || item.date;
//     return formatPersianDate(dateToFormat);
//   };

  // -------
    // ---------






  // NEW VERSION





    // ---------
  // ---------

 import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import mainImg from '../../Assets/speeches/v1_83.png';
import microphoneIcon from '../../Assets/icons/icon3.png';
import speechesIcon from '../../Assets/icons/icon2.png';
import videosIcon from '../../Assets/icons/icon4.png';
import productionsIcon from '../../Assets/icons/icon1.png';

import videoStyles from './Videos.module.css';
import audioStyles from './Audio.module.css';
import speechesStyles from './Speeches.module.css';
import productStyles from './Products.module.css';

const MediaBrowser = () => {
  const { year } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const activeYear = year ? parseInt(year, 10) : 1403;

  const englishToPersian = (num) => {
    const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
    const englishDigits = '0123456789';
    return String(num).replace(/[0-9]/g, (digit) => persianDigits[englishDigits.indexOf(digit)]);
  };

  // Dynamic routing based on the page
  const getMediaTypeFromPath = () => {
    const path = location.pathname;
    if (path.includes('/videos')) return 'videos';
    if (path.includes('/audios')) return 'audios';
    if (path.includes('/speeches')) return 'speeches';
    if (path.includes('/productions')) return 'productions';
    return 'speeches';
  };

  const currentMediaType = getMediaTypeFromPath();

  const [items, setItems] = useState([]);
  const [loadingState, setLoadingState] = useState(false);
  const [displayedItems, setDisplayedItems] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [yearNavigationIndex, setYearNavigationIndex] = useState(0);
  const [categoryType, setCategoryType] = useState(currentMediaType);
  const [error, setError] = useState(null);

  // Dynamic API config
  const getAPIConfig = (type) => {
    const configs = {
      speeches: {
        function: 'getSpeechesByYear',
        routePrefix: 'speeches',
        defaultItemsPerPage: 10,
        loadMoreIncrement: 10,
        category: 'speech'
      },
      videos: {
        function: 'getVideosByYear',
        routePrefix: 'videos',
        defaultItemsPerPage: 16,
        loadMoreIncrement: 8,
        category: 'video'
      },
      audios: {
        function: 'getAudiosByYear',
        routePrefix: 'audios',
        defaultItemsPerPage: 10,
        loadMoreIncrement: 10,
        category: 'audio'
      },
      productions: {
        function: 'getAllProductions',
        routePrefix: 'productions',
        defaultItemsPerPage: 12,
        loadMoreIncrement: 6,
        category: 'production'
      }
    };
    return configs[type] || configs.speeches;
  };

  const apiConfig = getAPIConfig(categoryType);

  useEffect(() => {
    const urlMediaType = getMediaTypeFromPath();
    if (urlMediaType !== categoryType) {
      setCategoryType(urlMediaType);
      setDisplayedItems(getAPIConfig(urlMediaType).defaultItemsPerPage);
      setItems([]);
    }
  }, [location.pathname]);

  const formatSlugForURL = (slug) => {
    if (!slug) return '';
    return slug.replace(/\s+/g, '-').trim();
  };

  const getStyles = () => {
    switch (apiConfig.category) {
      case 'video': return videoStyles;
      case 'audio': return audioStyles;
      case 'production': return productStyles;
      case 'speech':
      case 'speeches':
      default: return speechesStyles;
    }
  };

  const getCategoryIcon = (category) => {
    switch (category) {
      case 'speech':
      case 'speeches': return speechesIcon;
      case 'audio': return microphoneIcon;
      case 'video': return videosIcon;
      case 'production':
      case 'productions': return productionsIcon;
      default: return speechesIcon;
    }
  };

  const styles = getStyles();

  // Year navigation
  let availableYears;
  if (apiConfig.category === 'production') {
    availableYears = Array.from({ length: 34 }, (_, i) => 1404 - i);
  } else {
    availableYears = Array.from({ length: 34 }, (_, i) => 1403 - i);
  }
  const visibleYearRange = availableYears.slice(yearNavigationIndex, yearNavigationIndex + 4);

  const gregorianToPersianYear = (gregorianDate) => {
    const date = new Date(gregorianDate);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    if (month < 3 || (month === 3 && day < 21)) return year - 622;
    return year - 621;
  };

  const persianToGregorianYear = (persianYear) => persianYear + 621;

  const formatPersianDate = (dateString) => {
    const date = new Date(dateString);
    const formatted = new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(date);
    return englishToPersian(formatted);
  };

  const sortItemsByDate = (itemsToSort) => {
    return itemsToSort.sort((a, b) => {
      const dateA = new Date(a.originalDate || a.date);
      const dateB = new Date(b.originalDate || b.date);
      return dateB - dateA;
    });
  };

  const languagePicked = localStorage.getItem('siteLanguage') || 'fa';

  useEffect(() => {
    const fetchItems = async () => {
      setLoadingState(true);
      setItems([]);
      setError(null);

      try {
        const gregorianYear = persianToGregorianYear(activeYear);
        const nextGregorianYear = gregorianYear + 1;

        let apiUrl1 = "";
        let apiUrl2 = "";

        if (languagePicked === "fa") {
          apiUrl1 = `https://api.nasrollah.info/fa/?function=${apiConfig.function}&params=${gregorianYear}`;
          apiUrl2 = `https://api.nasrollah.info/fa/?function=${apiConfig.function}&params=${nextGregorianYear}`;
        } else {
          apiUrl1 = `https://api.nasrollah.info/ar/?function=${apiConfig.function}&params=${gregorianYear}`;
          apiUrl2 = `https://api.nasrollah.info/ar/?function=${apiConfig.function}&params=${nextGregorianYear}`;
        }

        const requestConfig = {
          timeout: 15000,
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          }
        };

        const [response1, response2] = await Promise.all([
          axios.get(apiUrl1, requestConfig),
          axios.get(apiUrl2, requestConfig)
        ]);

        const data1 = Array.isArray(response1.data) ? response1.data : [];
        const data2 = Array.isArray(response2.data) ? response2.data : [];
        const combinedData = [...data1, ...data2];

        if (combinedData.length > 0) {
          let transformedItems = combinedData
            .map(item => ({
              id: item.id_post,
              title: item.title_post,
              slug: item.slug_post,
              author: item.author_post,
              date: item.create_time_post,
              originalDate: item.original_time_post,
              status: item.status_post,
              featured_media: item.featured_media_post,
              featured_cover: item.featured_post,
              content: item.html_post,
              category: item.name_category || apiConfig.category,
              keywords: item.keywords_post,
              description: item.meta_description_post
            }))
            .filter(item => {
              const itemPersianYear = gregorianToPersianYear(item.originalDate || item.date);
              return itemPersianYear === activeYear;
            });

          transformedItems = sortItemsByDate(transformedItems);

          const paginatedItems = transformedItems.slice(0, displayedItems);

          setItems(paginatedItems);
          setTotalItems(transformedItems.length);
        } else {
          setItems([]);
          setTotalItems(0);
        }
      } catch (err) {
        console.error('Error fetching items:', err);
        setError({
          message: err.message,
          status: err.response?.status,
          type: 'fetch_error'
        });
        setItems([]);
        setTotalItems(0);
      }

      setLoadingState(false);
    };

    fetchItems();
  }, [activeYear, displayedItems, categoryType, apiConfig.function, languagePicked]);

  const handleYearSelection = (selectedYear) => {
    navigate(`/${apiConfig.routePrefix}/${selectedYear}`);
    setDisplayedItems(apiConfig.defaultItemsPerPage);
  };

  const handleShowMoreItems = () => {
    setDisplayedItems(prev => prev + apiConfig.loadMoreIncrement);
  };

  const navigateToNewerYears = () => {
    if (yearNavigationIndex > 0) {
      setYearNavigationIndex(prev => prev - 4);
    }
  };

  const navigateToOlderYears = () => {
    if (yearNavigationIndex + 4 < availableYears.length) {
      setYearNavigationIndex(prev => prev + 4);
    }
  };

  const formatDisplayDate = (item) => {
    const dateToFormat = item.originalDate || item.date;
    return formatPersianDate(dateToFormat);
  };

  if (languagePicked === 'fa') {
    if (error) {
      return (
        <div className="error-container" style={{
          padding: '60px 40px',
          textAlign: 'center',
          background: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)',
          borderRadius: '20px',
          border: '2px solid #fca5a5',
          margin: '20px auto',
          maxWidth: '600px'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '20px' }}>⚠️</div>
          <h2 style={{ color: '#dc2626', fontSize: '24px', marginBottom: '16px' }}>
            خطا در بارگذاری {categoryType === 'speeches' ? 'بيانات' : 
                   categoryType === 'videos' ? 'ویدیوها' :
                   categoryType === 'audios' ? 'فایل‌های صوتی' : 
                   categoryType === 'productions' ? 'تولیدات' : 'محتوا'}
          </h2>
          <p style={{ color: '#991b1b', marginBottom: '24px' }}>
            {error.status === 404 ? 'API endpoint یافت نشد' :
             error.status === 500 ? 'خطای سرور' :
             error.message.includes('timeout') ? 'زمان انتظار تمام شد' :
             error.message}
          </p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: 'linear-gradient(135deg, #1a5f3f 0%, #22543d 100%)',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '25px',
                cursor: 'pointer',
                fontWeight: '600'
              }}
            >
              تلاش مجدد
            </button>
            <button
              onClick={() => navigate('/')}
              style={{
                background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '25px',
                cursor: 'pointer',
                fontWeight: '600'
              }}
            >
              بازگشت به خانه
            </button>
          </div>
        </div>
      );
    }

    if (apiConfig.category === 'video') {
      return (
        <div className={styles.videoContainer}>
          {loadingState && (
            <div className={styles.videoLoadingMessage}>در حال بارگذاری ویدیوها...</div>
          )}

          {!loadingState && items.length === 0 && (
            <div className={styles.videoEmptyState}>
              هیچ ویدیویی برای سال {englishToPersian(activeYear)} موجود نیست
            </div>
          )}

          <div className={styles.videoGridLayout}>
            {items.map((item, index) => (
              <Link 
                key={`${activeYear}-${item.id}-${index}`} 
                to={`/${apiConfig.routePrefix}/${activeYear}/${formatSlugForURL(item.slug)}/${item.id}`}
                className={styles.videoTile}
                title={item.title}
                aria-label={`مشاهده ویدیو ${item.title}`}
              >
                <div className={styles.videoTileInner}>
                  <div className={styles.videoThumbnailWrapper}>
                    <img
                      src={item.featured_cover || mainImg}
                      alt={`${item.title} - ویدیو ${englishToPersian(activeYear)}`}
                      className={styles.videoThumbnail}
                      loading="lazy"
                      onError={(e) => {
                        e.target.src = mainImg;
                      }}
                    />
                    <div className={styles.videoPlayOverlay}>
                      <div className={styles.videoPlayIcon}>
                        <img 
                          src={videosIcon} 
                          alt="آیکون ویدیو"
                          style={{ width: '24px', height: '24px' }}
                        />
                      </div>
                    </div>
                  </div>
                  
                  <div className={styles.videoContent}>
                    <h3 className={styles.videoCaption}>{item.title}</h3>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className={styles.videoYearControls}>
            <button
              onClick={navigateToOlderYears}
              disabled={yearNavigationIndex + 4 >= availableYears.length}
              className={styles.videoNavBtn}
              aria-label="سال‌های قدیمی‌تر"
            >
              <span className={styles.videoArrowIcon}>‹</span>
              قبل
            </button>

            <div className={styles.videoYearSelector}>
              {visibleYearRange.map(yr => (
                <button
                  key={yr}
                  onClick={() => handleYearSelection(yr)}
                  className={`${styles.videoYearButton} ${activeYear === yr ? styles.videoActiveYear : ''}`}
                  aria-label={`سال ${englishToPersian(yr)}`}
                >
                  {englishToPersian(yr)}
                </button>
              ))}
              <span className={styles.videoYearEllipsis} aria-hidden="true">...</span>
            </div>

            <button
              onClick={navigateToNewerYears}
              disabled={yearNavigationIndex === 0}
              className={styles.videoNavBtn}
              aria-label="سال‌های جدیدتر"
            >
              بعد
              <span className={styles.videoArrowIcon}>›</span>
            </button>
          </div>

          {items.length < totalItems && (
            <div className={styles.videoLoadMoreArea}>
              <button onClick={handleShowMoreItems} className={styles.videoLoadMoreButton}>
                نمایش ویدیوهای بیشتر
              </button>
              <div className={styles.videoItemCounter}>
                نمایش {englishToPersian(items.length)} از {englishToPersian(totalItems)} ویدیو
              </div>
            </div>
          )}
        </div>
      );
    }

    if (apiConfig.category === 'audio') {
      return (
        <div className={styles.audioBrowserWrapper}>
          {loadingState && (
            <div className={styles.loadingIndicator}>در حال بارگذاری فایل‌های صوتی...</div>
          )}

          {!loadingState && items.length === 0 && (
            <div className={styles.noAudioMessage}>
              هیچ فایل صوتی برای سال {englishToPersian(activeYear)} موجود نیست
            </div>
          )}

          <div className={styles.audioRecordingsList}>
            {items.map((item, index) => (
              <Link 
                key={`${activeYear}-${item.id}-${index}`} 
                to={`/${apiConfig.routePrefix}/${activeYear}/${formatSlugForURL(item.slug)}/${item.id}`}
                className={styles.audioItemCard}
                title={item.title}
                aria-label={`گوش دادن به ${item.title}`}
              >
                <div className={styles.microphoneIconWrapper}>
                  <img 
                    src={item.featured_cover} 
                    alt="تصویر اصلی" 
                    className={styles.speakerProfileImage}
                    loading="lazy"
                  />
                </div>

                <div className={styles.audioContentSection}>
                  <h2 className={styles.audioRecordingTitle}>{item.title}</h2>
                  <div className={styles.audioMetaInfo}>
                    <span className={styles.recordingDateTime}>{formatDisplayDate(item)}</span>
                    <span className={styles.metaDataSeparator}> • </span>
                    <span className={styles.speakerFullName}>{item.author}</span>
                  </div>
                </div>

                <div className={styles.speakerProfileWrapper}>
                  {item.featured_media ? (
                    <img
                      src={microphoneIcon}
                      alt={`تصویر ${item.author}`}
                      className={styles.speakerProfileImage}
                      loading="lazy"
                      onError={(e) => {
                        e.target.src = getCategoryIcon(apiConfig.category); 
                      }}
                    />
                  ) : (
                    <img 
                      src={getCategoryIcon(apiConfig.category)} 
                      alt="آیکون دسته‌بندی" 
                      className={styles.speakerProfileImage}
                      loading="lazy"
                    />
                  )}
                </div>
              </Link>
            ))}
          </div>

          <div className={styles.yearNavigationBar}>
            <button
              onClick={navigateToOlderYears}
              disabled={yearNavigationIndex + 4 >= availableYears.length}
              className={styles.navigationButton}
              aria-label="سال‌های قدیمی‌تر"
            >
              <span className={styles.arrowIcon}>‹</span>
              <span>قبل</span>
            </button>

            <div className={styles.yearSelectionContainer}>
              {visibleYearRange.map(yr => (
                <button
                  key={yr}
                  onClick={() => handleYearSelection(yr)}
                  className={`${styles.yearSelectionBtn} ${activeYear === yr ? styles.activeYearBtn : ''}`}
                  aria-label={`سال ${englishToPersian(yr)}`}
                >
                  {englishToPersian(yr)} 
                </button>
              ))}
              <div className={styles.yearRangeDots} aria-hidden="true">...</div>
            </div>

            <button
              onClick={navigateToNewerYears}
              disabled={yearNavigationIndex === 0}
              className={styles.navigationButton}
              aria-label="سال‌های جدیدتر"
            >
              <span>بعد</span>
              <span className={styles.arrowIcon}>›</span>
            </button>
          </div>

          {items.length < totalItems && (
            <div className={styles.loadMoreAudioContainer}>
              <button onClick={handleShowMoreItems} className={styles.showMoreAudioBtn}>
                نمایش بیشتر
              </button>
              <div className={styles.audioCountDisplay}>
                نمایش {englishToPersian(items.length)} از {englishToPersian(totalItems)}
              </div>
            </div>
          )}
        </div>
      );
    }
    if (apiConfig.category === 'production') {
      return (
        <div className={styles.productsWrapper}>
          {loadingState && (
            <div className={styles.loadingIndicator}>در حال بارگذاری تولیدات...</div>
          )}

          {!loadingState && items.length === 0 && (
            <div className={styles.noProductsMessage}>
              هیچ تولیدی برای سال {englishToPersian(activeYear)} موجود نیست
            </div>
          )}

          <div className={styles.productsGrid}>
            {items.map((item, index) => (
              <Link 
                key={`${activeYear}-${item.id}-${index}`} 
                to={`/${apiConfig.routePrefix}/${activeYear}/${formatSlugForURL(item.slug)}/${item.id}`}
                className={styles.productCard}
                title={item.title}
                aria-label={`مشاهده ${item.title}`}
              >
                <div className={styles.productImageContainer}>
                  <img
                    src={item.featured_cover || mainImg}
                    alt={`${item.title} - تولید ${englishToPersian(activeYear)}`}
                    className={styles.productImage}
                    loading="lazy"
                    onError={(e) => {
                      e.target.src = mainImg;
                    }}
                  />
                  <div className={styles.productOverlay}>
                    <div className={styles.productIcon}>
                      <img 
                        src={getCategoryIcon('production')} 
                        alt="آیکون تولید"
                        style={{ width: '24px', height: '24px' }}
                      />
                    </div>
                  </div>
                </div>
                
                <div className={styles.productContent}>
                  <h3 className={styles.productTitle}>{item.title}</h3>
                  <div className={styles.productMeta}>
                    <span className={styles.productDate}>{formatDisplayDate(item)}</span>
                    <span className={styles.productAuthor}>{item.author}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className={styles.yearNavigation}>
            <button
              onClick={navigateToOlderYears}
              disabled={yearNavigationIndex === 0}
              className={styles.navButton}
              aria-label="سال‌های قدیمی‌تر"
            >
              <span className={styles.arrow}>‹</span>
              قبل
            </button>

            <div className={styles.yearButtons}>
              {visibleYearRange.map(yr => (
                <button
                  key={yr}
                  onClick={() => handleYearSelection(yr)}
                  className={`${styles.yearBtn} ${activeYear === yr ? styles.activeYear : ''}`}
                  aria-label={`سال ${englishToPersian(yr)}`}
                >
                  {englishToPersian(yr)}
                </button>
              ))}
              <span className={styles.yearDots}>...</span>
            </div>

            <button
              onClick={navigateToNewerYears}
              disabled={yearNavigationIndex + 4 >= availableYears.length}
              className={styles.navButton}
              aria-label="سال‌های جدیدتر"
            >
              بعد
              <span className={styles.arrow}>›</span>
            </button>
          </div>

          {items.length < totalItems && (
            <div className={styles.loadMoreSection}>
              <button onClick={handleShowMoreItems} className={styles.loadMoreBtn}>
                نمایش تولیدات بیشتر
              </button>
              <div className={styles.productCount}>
                نمایش {englishToPersian(items.length)} از {englishToPersian(totalItems)} تولید
              </div>
            </div>
          )}
        </div>
      );
    }

    return (
      <div className={styles.yearBrowserContainer}>
        {loadingState && <div className={styles.loading}>در حال بارگذاری...</div>}

        {!loadingState && items.length === 0 && (
          <div className={styles.noArticles}>
            هیچ مطلبی برای سال {englishToPersian(activeYear)} موجود نیست
          </div>
        )}

        <div className={styles.articlesList}>
          {items.map((item, index) => (
            <Link 
              key={`${activeYear}-${item.id}-${index}`} 
              to={`/${apiConfig.routePrefix}/${activeYear}/${formatSlugForURL(item.slug)}/${item.id}`}
              className={styles.articleItem}
              title={item.title}
              aria-label={`مطالعه ${item.title}`}
            >
              <div className={styles.articleIconContainer}>
                <img 
                  src={item.featured_media} 
                  alt="تصویر اصلی" 
                  className={styles.profileImage}
                  loading="lazy"
                />
              </div>

              <div className={styles.articleContent}>
                <h2 className={styles.articleTitle}>{item.title}</h2>
                <div className={styles.articleMeta}>
                  <span className={styles.articleDate}>{formatDisplayDate(item)}</span>
                  <span className={styles.articleSeparator}> • </span>
                  <span className={styles.articleAuthor}>{item.author}</span>
                </div>
              </div>

              <div className={styles.articleProfileContainer}>
                <img 
                  src={getCategoryIcon(apiConfig.category)} 
                  alt="آیکون دسته‌بندی" 
                  className={styles.speechIcon}
                  loading="lazy"
                />
              </div>
            </Link>
          ))}
        </div>

        <div className={styles.yearNavigation}>
          <button
            onClick={navigateToOlderYears}
            disabled={yearNavigationIndex + 4 >= availableYears.length}
            className={styles.navBtn}
            aria-label="سال‌های قدیمی‌تر"
          >
            <span className={styles.arrow}>‹</span>
            <span>قبل</span>
          </button>

          <div className={styles.yearSelector}>
            {visibleYearRange.map(yr => (
              <button
                key={yr}
                onClick={() => handleYearSelection(yr)}
                className={`${styles.yearBtn} ${activeYear === yr ? styles.active : ''}`}
                aria-label={`سال ${englishToPersian(yr)}`}
              >
                {englishToPersian(yr)} 
              </button>
            ))}
            <div className={styles.dots} aria-hidden="true">...</div>
          </div>

          <button
            onClick={navigateToNewerYears}
            disabled={yearNavigationIndex === 0}
            className={styles.navBtn}
            aria-label="سال‌های جدیدتر"
          >
            <span>بعد</span>
            <span className={styles.arrow}>›</span>
          </button>
        </div>

        {items.length < totalItems && (
          <div className={styles.loadMoreContainer}>
            <button onClick={handleShowMoreItems} className={styles.loadMoreBtn}>
              نمایش بیشتر
            </button>
            <div className={styles.showingCount}>
              نمایش {englishToPersian(items.length)} از {englishToPersian(totalItems)}
            </div>
          </div>
        )}
      </div>
    );
  }

  // Arabic View
  if (error) {
    return (
      <div className="error-container" style={{
        padding: '60px 40px',
        textAlign: 'center',
        background: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)',
        borderRadius: '20px',
        border: '2px solid #fca5a5',
        margin: '20px auto',
        maxWidth: '600px'
      }}>
        <div style={{ fontSize: '48px', marginBottom: '20px' }}>⚠️</div>
        <h2 style={{ color: '#dc2626', fontSize: '24px', marginBottom: '16px' }}>
          خطأ في تحميل {categoryType === 'speeches' ? 'البيانات' : 
                 categoryType === 'videos' ? 'الفيديوهات' :
                 categoryType === 'audios' ? 'الملفات الصوتيّة' : 
                 categoryType === 'productions' ? 'الإنتاج' : 'المحتوى'}
        </h2>
        <p style={{ color: '#991b1b', marginBottom: '24px' }}>
          {error.status === 404 ? 'ما لقينا نقطة API' :
           error.status === 500 ? 'خطأ بالسيرفر' :
           error.message.includes('timeout') ? 'خلص وقت الانتظار' :
           error.message}
        </p>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: 'linear-gradient(135deg, #1a5f3f 0%, #22543d 100%)',
              color: 'white',
              border: 'none',
              padding: '12px 24px',
              borderRadius: '25px',
              cursor: 'pointer',
              fontWeight: '600'
            }}
          >
            جرّب مرّة تانية
          </button>
          <button
            onClick={() => navigate('/')}
            style={{
              background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)',
              color: 'white',
              border: 'none',
              padding: '12px 24px',
              borderRadius: '25px',
              cursor: 'pointer',
              fontWeight: '600'
            }}
          >
            ارجع عالبيت
          </button>
        </div>
      </div>
    );
  }

  if (apiConfig.category === 'video') {
    return (
      <div className={styles.videoContainer}>
        {loadingState && (
          <div className={styles.videoLoadingMessage}>جاری نحمّل الفيديوهات...</div>
        )}

        {!loadingState && items.length === 0 && (
          <div className={styles.videoEmptyState}>
            ما في فيديوهات لسنة {englishToPersian(activeYear)}
          </div>
        )}

        <div className={styles.videoGridLayout}>
          {items.map((item, index) => (
            <Link 
              key={`${activeYear}-${item.id}-${index}`} 
              to={`/${apiConfig.routePrefix}/${activeYear}/${formatSlugForURL(item.slug)}/${item.id}`}
              className={styles.videoTile}
              title={item.title}
              aria-label={`شوف الفيديو ${item.title}`}
            >
              <div className={styles.videoTileInner}>
                <div className={styles.videoThumbnailWrapper}>
                  <img
                    src={item.featured_cover || mainImg}
                    alt={`${item.title} - فيديو ${englishToPersian(activeYear)}`}
                    className={styles.videoThumbnail}
                    loading="lazy"
                    onError={(e) => {
                      e.target.src = mainImg;
                    }}
                  />
                  <div className={styles.videoPlayOverlay}>
                    <div className={styles.videoPlayIcon}>
                      <img 
                        src={videosIcon} 
                        alt="أيقونة الفيديو"
                        style={{ width: '24px', height: '24px' }}
                      />
                    </div>
                  </div>
                </div>
                
                <div className={styles.videoContent}>
                  <h3 className={styles.videoCaption}>{item.title}</h3>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className={styles.videoYearControls}>
          <button
            onClick={navigateToOlderYears}
            disabled={yearNavigationIndex + 4 >= availableYears.length}
            className={styles.videoNavBtn}
            aria-label="سنوات أقدم"
          >
            <span className={styles.videoArrowIcon}>‹</span>
            قبل
          </button>

          <div className={styles.videoYearSelector}>
            {visibleYearRange.map(yr => (
              <button
                key={yr}
                onClick={() => handleYearSelection(yr)}
                className={`${styles.videoYearButton} ${activeYear === yr ? styles.videoActiveYear : ''}`}
                aria-label={`سنة ${englishToPersian(yr)}`}
              >
                {englishToPersian(yr)}
              </button>
            ))}
            <span className={styles.videoYearEllipsis} aria-hidden="true">...</span>
          </div>

          <button
            onClick={navigateToNewerYears}
            disabled={yearNavigationIndex === 0}
            className={styles.videoNavBtn}
            aria-label="سنوات أحدث"
          >
            بعد
            <span className={styles.videoArrowIcon}>›</span>
          </button>
        </div>

        {items.length < totalItems && (
          <div className={styles.videoLoadMoreArea}>
            <button onClick={handleShowMoreItems} className={styles.videoLoadMoreButton}>
              فوّت فيديوهات أكتر
            </button>
            <div className={styles.videoItemCounter}>
              عم نفوّت {englishToPersian(items.length)} من {englishToPersian(totalItems)} فيديو
            </div>
          </div>
        )}
      </div>
    );
  }

  if (apiConfig.category === 'audio') {
    return (
      <div className={styles.audioBrowserWrapper}>
        {loadingState && (
          <div className={styles.loadingIndicator}>جاری نحمّل الملفات الصوتيّة...</div>
        )}

        {!loadingState && items.length === 0 && (
          <div className={styles.noAudioMessage}>
            ما في ملفات صوتيّة لسنة {englishToPersian(activeYear)}
          </div>
        )}

        <div className={styles.audioRecordingsList}>
          {items.map((item, index) => (
            <Link 
              key={`${activeYear}-${item.id}-${index}`} 
              to={`/${apiConfig.routePrefix}/${activeYear}/${formatSlugForURL(item.slug)}/${item.id}`}
              className={styles.audioItemCard}
              title={item.title}
              aria-label={`اسمع لـ ${item.title}`}
            >
              <div className={styles.microphoneIconWrapper}>
                <img 
                  src={item.featured_cover} 
                  alt="الصورة الأساسيّة" 
                  className={styles.speakerProfileImage}
                  loading="lazy"
                />
              </div>

              <div className={styles.audioContentSection}>
                <h2 className={styles.audioRecordingTitle}>{item.title}</h2>
                <div className={styles.audioMetaInfo}>
                  <span className={styles.recordingDateTime}>{formatDisplayDate(item)}</span>
                  <span className={styles.metaDataSeparator}> • </span>
                  <span className={styles.speakerFullName}>{item.author}</span>
                </div>
              </div>

              <div className={styles.speakerProfileWrapper}>
                {item.featured_media ? (
                  <img
                    src={microphoneIcon}
                    alt={`صورة ${item.author}`}
                    className={styles.speakerProfileImage}
                    loading="lazy"
                    onError={(e) => {
                      e.target.src = getCategoryIcon(apiConfig.category); 
                    }}
                  />
                ) : (
                  <img 
                    src={getCategoryIcon(apiConfig.category)} 
                    alt="أيقونة الفئة" 
                    className={styles.speakerProfileImage}
                    loading="lazy"
                  />
                )}
              </div>
            </Link>
          ))}
        </div>

        <div className={styles.yearNavigationBar}>
          <button
            onClick={navigateToOlderYears}
            disabled={yearNavigationIndex + 4 >= availableYears.length}
            className={styles.navigationButton}
            aria-label="سنوات أقدم"
          >
            <span className={styles.arrowIcon}>‹</span>
            <span>قبل</span>
          </button>

          <div className={styles.yearSelectionContainer}>
            {visibleYearRange.map(yr => (
              <button
                key={yr}
                onClick={() => handleYearSelection(yr)}
                className={`${styles.yearSelectionBtn} ${activeYear === yr ? styles.activeYearBtn : ''}`}
                aria-label={`سنة ${englishToPersian(yr)}`}
              >
                {englishToPersian(yr)} 
              </button>
            ))}
            <div className={styles.yearRangeDots} aria-hidden="true">...</div>
          </div>

          <button
            onClick={navigateToNewerYears}
            disabled={yearNavigationIndex === 0}
            className={styles.navigationButton}
            aria-label="سنوات أحدث"
          >
            <span>بعد</span>
            <span className={styles.arrowIcon}>›</span>
          </button>
        </div>

        {items.length < totalItems && (
          <div className={styles.loadMoreAudioContainer}>
            <button onClick={handleShowMoreItems} className={styles.showMoreAudioBtn}>
              فوّت أكتر
            </button>
            <div className={styles.audioCountDisplay}>
              عم نفوّت {englishToPersian(items.length)} من {englishToPersian(totalItems)}
            </div>
          </div>
        )}
      </div>
    );
  }

  if (apiConfig.category === 'production') {
    return (
      <div className={styles.productsWrapper}>
        {loadingState && (
          <div className={styles.loadingIndicator}>جاری نحمّل الإنتاج...</div>
        )}

        {!loadingState && items.length === 0 && (
          <div className={styles.noProductsMessage}>
            ما في إنتاج لسنة {englishToPersian(activeYear)}
          </div>
        )}

        <div className={styles.productsGrid}>
          {items.map((item, index) => (
            <Link 
              key={`${activeYear}-${item.id}-${index}`} 
              to={`/${apiConfig.routePrefix}/${activeYear}/${formatSlugForURL(item.slug)}/${item.id}`}
              className={styles.productCard}
              title={item.title}
              aria-label={`شوف ${item.title}`}
            >
              <div className={styles.productImageContainer}>
                <img
                  src={item.featured_cover || mainImg}
                  alt={`${item.title} - إنتاج ${englishToPersian(activeYear)}`}
                  className={styles.productImage}
                  loading="lazy"
                  onError={(e) => {
                    e.target.src = mainImg;
                  }}
                />
                <div className={styles.productOverlay}>
                  <div className={styles.productIcon}>
                    <img 
                      src={getCategoryIcon('production')} 
                      alt="أيقونة الإنتاج"
                      style={{ width: '24px', height: '24px' }}
                    />
                  </div>
                </div>
              </div>
              
              <div className={styles.productContent}>
                <h3 className={styles.productTitle}>{item.title}</h3>
                <div className={styles.productMeta}>
                  <span className={styles.productDate}>{formatDisplayDate(item)}</span>
                  <span className={styles.productAuthor}>{item.author}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className={styles.yearNavigation}>
          <button
            onClick={navigateToOlderYears}
            disabled={yearNavigationIndex === 0}
            className={styles.navButton}
            aria-label="سنوات أقدم"
          >
            <span className={styles.arrow}>‹</span>
            قبل
          </button>

          <div className={styles.yearButtons}>
            {visibleYearRange.map(yr => (
              <button
                key={yr}
                onClick={() => handleYearSelection(yr)}
                className={`${styles.yearBtn} ${activeYear === yr ? styles.activeYear : ''}`}
                aria-label={`سنة ${englishToPersian(yr)}`}
              >
                {englishToPersian(yr)}
              </button>
            ))}
            <span className={styles.yearDots}>...</span>
          </div>

          <button
            onClick={navigateToNewerYears}
            disabled={yearNavigationIndex + 4 >= availableYears.length}
            className={styles.navButton}
            aria-label="سنوات أحدث"
          >
            بعد
            <span className={styles.arrow}>›</span>
          </button>
        </div>

        {items.length < totalItems && (
          <div className={styles.loadMoreSection}>
            <button onClick={handleShowMoreItems} className={styles.loadMoreBtn}>
              فوّت إنتاج أكتر
            </button>
            <div className={styles.productCount}>
              عم نفوّت {englishToPersian(items.length)} من {englishToPersian(totalItems)} إنتاج
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={styles.yearBrowserContainer}>
      {loadingState && <div className={styles.loading}>جاری نحمّل...</div>}

      {!loadingState && items.length === 0 && (
        <div className={styles.noArticles}>
          ما في خطابات لسنة {englishToPersian(activeYear)}
        </div>
      )}

      <div className={styles.articlesList}>
        {items.map((item, index) => (
          <Link 
            key={`${activeYear}-${item.id}-${index}`} 
            to={`/${apiConfig.routePrefix}/${activeYear}/${formatSlugForURL(item.slug)}/${item.id}`}
            className={styles.articleItem}
            title={item.title}
            aria-label={`اقرا ${item.title}`}
          >
            <div className={styles.articleIconContainer}>
              <img 
                src={item.featured_media} 
                alt="الصورة الأساسيّة" 
                className={styles.profileImage}
                loading="lazy"
              />
            </div>

            <div className={styles.articleContent}>
              <h2 className={styles.articleTitle}>{item.title}</h2>
              <div className={styles.articleMeta}>
                <span className={styles.articleDate}>{formatDisplayDate(item)}</span>
                <span className={styles.articleSeparator}> • </span>
                <span className={styles.articleAuthor}>{item.author}</span>
              </div>
            </div>

            <div className={styles.articleProfileContainer}>
              <img 
                src={getCategoryIcon(apiConfig.category)} 
                alt="أيقونة الفئة" 
                className={styles.speechIcon}
                loading="lazy"
              />
            </div>
          </Link>
        ))}
      </div>

      <div className={styles.yearNavigation}>
        <button
          onClick={navigateToOlderYears}
          disabled={yearNavigationIndex + 4 >= availableYears.length}
          className={styles.navBtn}
          aria-label="سنوات أقدم"
        >
          <span className={styles.arrow}>‹</span>
          <span>قبل</span>
        </button>

        <div className={styles.yearSelector}>
          {visibleYearRange.map(yr => (
            <button
              key={yr}
              onClick={() => handleYearSelection(yr)}
              className={`${styles.yearBtn} ${activeYear === yr ? styles.active : ''}`}
              aria-label={`سنة ${englishToPersian(yr)}`}
            >
              {englishToPersian(yr)} 
            </button>
          ))}
          <div className={styles.dots} aria-hidden="true">...</div>
        </div>

        <button
          onClick={navigateToNewerYears}
          disabled={yearNavigationIndex === 0}
          className={styles.navBtn}
          aria-label="سنوات أحدث"
        >
          <span>بعد</span>
          <span className={styles.arrow}>›</span>
        </button>
      </div>

      {items.length < totalItems && (
        <div className={styles.loadMoreContainer}>
          <button onClick={handleShowMoreItems} className={styles.loadMoreBtn}>
            فوّت أكتر
          </button>
          <div className={styles.showingCount}>
            عم نفوّت {englishToPersian(items.length)} من {englishToPersian(totalItems)}
          </div>
        </div>
      )}
    </div>
  );
};

export default MediaBrowser;
